import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { DatePicker, Form } from 'antd';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Box, Flex, Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import { FichaContactologicaFormulario } from './fichaContactologica.form';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import ReadOnly from '../../shared/components/dataEntry/ReadOnly';
import EditableTable from '../../shared/containers/EditableTable';
import { columns_1, columns_2, columns_3 } from './contactologiaTables';
import { isNumeric } from '../../../helpers/common.helper';

export function FichaContactologicaFormPrescripcion({
  watch,
  create,
  form,
  onSetValue,
  datosGraduacion,
  onError,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo } = params;
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const tiendas = useSelector(state => state.core.tiendas);
  const sagas = useSelector(state => state.sagas);
  const datosGraduacionOriginal = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica);
  const tiendaCreate = create ? tiendas.find(e => e.id === tiendaId) : null;
  const tiendaCreateName = create && tiendaCreate ? tiendaCreate.nombre : null;
  const { getFieldDecorator } = form;
  const [error, setError] = useState({errors:false, message: ''});
  useEffect(() => {
  }, []);
  const prescripcion = datosGraduacion && datosGraduacion.prescripcion;
  const dataSource = [
    {
      key: '1',
      ojo: 'Dcho.',
      eje: prescripcion && prescripcion.ojo_derecho?.eje,
      cilindro: prescripcion && prescripcion.ojo_derecho?.cilindro,
      esfLejos: prescripcion && prescripcion.ojo_derecho?.esfera_lejos,
      esfCerca: prescripcion && prescripcion.ojo_derecho?.esfera_cerca,
      adicion: prescripcion && prescripcion.ojo_derecho?.adicion,
      avcc: prescripcion && prescripcion.ojo_derecho?.avcc,
      ojoDom: prescripcion && prescripcion.ojo_derecho?.ojo_dominante,
    },
    {
      key: '2',
      ojo: 'Izdo.',
      eje: prescripcion && prescripcion.ojo_izquierdo?.eje,
      cilindro: prescripcion && prescripcion.ojo_izquierdo?.cilindro,
      esfLejos: prescripcion && prescripcion.ojo_izquierdo?.esfera_lejos,
      esfCerca: prescripcion && prescripcion.ojo_izquierdo?.esfera_cerca,
      adicion: prescripcion && prescripcion.ojo_izquierdo?.adicion,
      avcc: prescripcion && prescripcion.ojo_izquierdo?.avcc,
      ojoDom: prescripcion && prescripcion.ojo_izquierdo?.ojo_dominante,

    },
  ];
  const handleTableDataChange = ({ rowKey, newRow, dataSource }) => {
    let copiaPrescripcion = null;
    const nuevoEje = newRow.eje ? newRow.eje.replace('º', '') : null;
    if (!isNumeric(nuevoEje) && nuevoEje !== '' && nuevoEje !== null) return;
    const nuevoCilindro = newRow.cilindro ? newRow.cilindro.replace('+', '') : null;
    if (!isNumeric(nuevoCilindro) && nuevoCilindro !== '' && nuevoCilindro !== null) return;
    let nuevoEsferaLejos = newRow.esfLejos ? newRow.esfLejos.replace('+', '') : null;
    if (!isNumeric(nuevoEsferaLejos) && nuevoEsferaLejos !== '' && nuevoEsferaLejos !== null) return;
    let nuevoEsferaCerca = newRow.esfCerca ? newRow.esfCerca.replace('+', '') : null;
    if (!isNumeric(nuevoEsferaCerca) && nuevoEsferaCerca !== '' && nuevoEsferaCerca !== null) return;
    const nuevoAVCC = newRow.avcc ? newRow.avcc : null;
    if (!isNumeric(nuevoAVCC) && nuevoAVCC !== '' && nuevoAVCC !== null) return;
    let nuevoAdicion = newRow.adicion ? newRow.adicion : null;
    if (!isNumeric(nuevoAdicion) && nuevoAdicion !== '' && nuevoAdicion !== null) return;

    const nuevoOjoDominante = newRow.ojoDom ? newRow.ojoDom : null;
    if (nuevoOjoDominante !== 'D' && nuevoOjoDominante !== 'N' && nuevoOjoDominante !== 'Ninguno' && nuevoOjoDominante !== '' && nuevoOjoDominante !== null) return;
    if (!nuevoAdicion && nuevoEsferaLejos !== null && nuevoEsferaCerca !== null) {
      if (nuevoEsferaLejos > nuevoEsferaCerca) {
        nuevoEsferaCerca = nuevoEsferaLejos;
      }
      nuevoAdicion = nuevoEsferaLejos - nuevoEsferaCerca;
    }
    if (nuevoAdicion && (nuevoEsferaLejos !== null || nuevoEsferaCerca !== null)) {
      if ((nuevoEsferaLejos === null || nuevoEsferaLejos === '') && (nuevoEsferaCerca !== null || nuevoEsferaCerca !== '')) {
        nuevoEsferaLejos = (parseFloat(nuevoAdicion) + parseFloat(nuevoEsferaCerca)).toFixed(2);
      } else if ((nuevoEsferaCerca === null || nuevoEsferaCerca === '') && (nuevoEsferaLejos !== null || nuevoEsferaLejos !== '')) {
        nuevoEsferaCerca = (nuevoEsferaLejos - nuevoAdicion).toFixed(2);
      } else if ((nuevoEsferaLejos !== '' || nuevoEsferaLejos !== null) && (nuevoEsferaCerca !== null || nuevoEsferaCerca !== '')) {
        const datosOriginalesOjo = dataSource[parseInt(rowKey, 10) - 1];
        if (datosOriginalesOjo.esfCerca && datosOriginalesOjo.esfCerca.replace('+', '') != nuevoEsferaCerca) {
          nuevoEsferaLejos = (parseFloat(nuevoAdicion) + parseFloat(nuevoEsferaCerca)).toFixed(2);
        } else {
          nuevoEsferaCerca = (nuevoEsferaLejos - nuevoAdicion).toFixed(2);
        }
      }
    }
    if (nuevoEsferaCerca) nuevoEsferaCerca = parseFloat(nuevoEsferaCerca).toFixed(2);
    if (nuevoEsferaLejos) nuevoEsferaLejos = parseFloat(nuevoEsferaLejos).toFixed(2);
    if (rowKey === '1') {
      const ojo_derecho = {
        eje: nuevoEje !== '' && nuevoEje !== null ? `${Math.abs(parseInt(nuevoEje, 10))}º` : null,
        cilindro: nuevoCilindro > 0 ? `+${ parseFloat(nuevoCilindro).toFixed(2)}` : nuevoCilindro,
        esfera_lejos: nuevoEsferaLejos > 0 ? `+${nuevoEsferaLejos}` : nuevoEsferaLejos,
        esfera_cerca: nuevoEsferaCerca > 0 ? `+${nuevoEsferaCerca}` : nuevoEsferaCerca,
        adicion: nuevoAdicion !== '' && nuevoAdicion !== null ? Math.abs(nuevoAdicion).toFixed(2) : null,
        avcc: nuevoAVCC,
        ojo_dominante: nuevoOjoDominante,
      };

      copiaPrescripcion = datosGraduacion.prescripcion ? {
        ...datosGraduacion.prescripcion,
        ojo_derecho,
      } : { ojo_derecho };
    } else {
      const ojo_izquierdo = {
        eje: nuevoEje !== '' && nuevoEje !== null ? `${Math.abs(parseInt(nuevoEje, 10))}º` : null,
        cilindro: nuevoCilindro > 0 ? `+${ parseFloat(nuevoCilindro).toFixed(2)}` : nuevoCilindro,
        esfera_lejos: nuevoEsferaLejos > 0 ? `+${nuevoEsferaLejos}` : nuevoEsferaLejos,
        esfera_cerca: nuevoEsferaCerca > 0 ? `+${nuevoEsferaCerca}` : nuevoEsferaCerca,
        adicion: nuevoAdicion !== '' && nuevoAdicion !== null ? Math.abs(nuevoAdicion).toFixed(2) : null,
        avcc: nuevoAVCC,
        ojo_dominante: nuevoOjoDominante,
      };
      copiaPrescripcion = datosGraduacion.prescripcion ? {
        ...datosGraduacion.prescripcion,
        ojo_izquierdo,
      } : { ojo_izquierdo };
    }
    onSetValue({ prescripcion: copiaPrescripcion }, {});
    if(copiaPrescripcion.ojo_derecho.eje != null && copiaPrescripcion.ojo_derecho.cilindro == null) {
      onError(true);
      setError({errors: true, message: 'Debe existir un valor de cilindro si existe un valor de eje en el ojo derecho!'});
    }else if(copiaPrescripcion.ojo_derecho.eje == null && copiaPrescripcion.ojo_derecho.cilindro != null){
      onError(true);
      setError({errors: true, message: 'Debe existir un valor de eje si existe un valor de cilindro en el ojo derecho!'});
    }else if(copiaPrescripcion.ojo_izquierdo.eje != null && copiaPrescripcion.ojo_izquierdo.cilindro == null){
      onError(true);
      setError({errors: true, message: 'Debe existir un valor de cilindro si existe un valor de eje en el ojo izquierdo!'});
    }else if((copiaPrescripcion.ojo_izquierdo.eje == null && copiaPrescripcion.ojo_izquierdo.cilindro != null)){
      onError(true);
      setError({errors: true, message: 'Debe existir un valor de eje si existe un valor de cilindro en el ojo izquierdo!'});
    }
    else{
      onError(false);
      setError({errors: false});
    }
  };
  return (
    <Flex flexDirection="column" flexGrow="1">
      <Text width="425px"  fontFamily="Open Sans" color="#3E3E3C" fontWeight="600" fontSize="16px" translationId="ficha_contactologica.prescripcion">Prescripción</Text>
      <EditableTable
        mt="16px"
        readOnly={watch}
        size="middle"
        basic
        rowSelection={false}
        className="table-prescripcion"
        onRowChange={data => handleTableDataChange(data)}
        dataSource={dataSource}
        columns={columns_3}
        pagination={false}
      />
      {error.errors && <Text color="red" pl={8}>{error.message}</Text>}
    </Flex>
  );
}
